export class BookingOverviewList {
  sharedVehicleGroupHashId: string = '';
  vehicleHashId: string = '';
  bookingHashId: string = '';
  approvalAdmin : string;
  approvalAdminHashId : string;
  bookingType: string = '';
  bookingReferenceId: string;
  isApproverejectEnable : boolean;
  translatedBookingStatus:string;
  reccuringID: string;
  licenceTag: string;
  driver: string;
  adminHashId : string;
  sharedVehicleGroup: String;
  startDateTime: string;
  endDateTime: string;
  translatedBookingType : string;
  bookingStatus: string = '';
  adminRemarks: string;
  driverRemarks: string;
  remarks: string;
  isChecked: boolean;
  listOfBookingHashId: string[] = []
  isBookingCancel: boolean;
  isBookingAbort: boolean;
  isBookingRevoke: boolean;
  isBookingEditable: string;
  isRecurringSeriesEditable: boolean;
  totalExpense: string;
  totalKm: string;
  vehicleImagePath: string;
  driverHashId: string;
  isVehicleDeleted: boolean;
  isApprovalPersonLinkEditable : boolean;
  approvalAdminFullName : string;
  isApprovalPermissionEnable : boolean;
  isPersonDeleted: boolean;
  isSharedVehicleGroupDeleted: boolean;
  sharedVehicleGroupHashIdList: string[] = [];
  vehicleHashIdList: string[] = [];
  driverHashIdList: string[] = [];
  bookingStatusList: string[] = [''];
  bookingTypeList: string[] = [''];
  adminHashIdList:string[]=[];
  searchAdminNameList: string[] = [];
  searchLicenceTagList: string[] = [];
  searchDriverNameList: string[] = [];
  searchSVGNameList: string[] = [];
  applyDateFilter: boolean = true;
  isDeletable: boolean = true;
  localTimeZone: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/models/booking-overviewlist.model.ts